import { color } from '@chewy/kib-utilities'

export const chirpBackgroundAndBordersColors = {
  'ui-bg/10': color.get('ui-bg', '10'),
  'ui-bg/11': color.get('ui-bg', '11'),
  'ui-bg/12': color.get('ui-bg', '12'),
  'ui-bg/13': color.get('ui-bg', '13'),
  'ui-bg/14': color.get('ui-bg', '14'),
  'ui-bg/15': color.get('ui-bg', '15'),
  'ui-bg/16': color.get('ui-bg', '16'),
  'ui-bg/17': color.get('ui-bg', '17'),
  'ui-bg/18': color.get('ui-bg', '18'),
  'ui-bg/19': color.get('ui-bg', '19'),
  'ui-bg/20': color.get('ui-bg', '20'),
  'ui-bg/primary': color.get('ui-bg', 'primary'),
  'ui-bg/02': color.get('ui-bg', '02'),
  'ui-bg/03': color.get('ui-bg', '03'),
  'ui-bg/04': color.get('ui-bg', '04'),
  'ui-bg/05': color.get('ui-bg', '05'),
  'ui-bg/06': color.get('ui-bg', '06'),
  'ui-bg/07': color.get('ui-bg', '07'),
  'ui-bg/08': color.get('ui-bg', '08'),
  'ui-bg/primary-inverse': color.get('ui-bg', 'primary-inverse'),
  'ui-bg/09': color.get('ui-bg', '09'),
  'ui-bg/overlay/primary': color.get('ui-bg', 'overlay', 'primary'),
  'ui-bg/overlay/02': color.get('ui-bg', 'overlay', '02'),
  'ui-bg/brand/primary': color.get('ui-bg', 'brand', 'primary'),
  'ui-bg/brand/alternate': color.get('ui-bg', 'brand', 'alternate'),
  'ui-bg/brand/accent/10': color.get('ui-bg', 'brand', 'accent', '10'),
  'ui-bg/brand/accent/11': color.get('ui-bg', 'brand', 'accent', '11'),
  'ui-bg/brand/accent/12': color.get('ui-bg', 'brand', 'accent', '12'),
  'ui-bg/brand/accent/13': color.get('ui-bg', 'brand', 'accent', '13'),
  'ui-bg/brand/accent/14': color.get('ui-bg', 'brand', 'accent', '14'),
  'ui-bg/brand/accent/15': color.get('ui-bg', 'brand', 'accent', '15'),
  'ui-bg/brand/accent/01': color.get('ui-bg', 'brand', 'accent', '01'),
  'ui-bg/brand/accent/02': color.get('ui-bg', 'brand', 'accent', '02'),
  'ui-bg/brand/accent/03': color.get('ui-bg', 'brand', 'accent', '03'),
  'ui-bg/brand/accent/04': color.get('ui-bg', 'brand', 'accent', '04'),
  'ui-bg/brand/accent/05': color.get('ui-bg', 'brand', 'accent', '05'),
  'ui-bg/brand/accent/06': color.get('ui-bg', 'brand', 'accent', '06'),
  'ui-bg/brand/accent/07': color.get('ui-bg', 'brand', 'accent', '07'),
  'ui-bg/brand/accent/08': color.get('ui-bg', 'brand', 'accent', '08'),
  'ui-bg/brand/accent/09': color.get('ui-bg', 'brand', 'accent', '09'),
}

export const chirpMessagesColors = {
  'message/success/primary': color.get('message', 'success', 'primary'),
  'message/success/02': color.get('message', 'success', '02'),
  'message/success/03': color.get('message', 'success', '03'),
  'message/success/04': color.get('message', 'success', '04'),
  'message/success/05': color.get('message', 'success', '05'),
  'message/success/06': color.get('message', 'success', '06'),
  'message/warning/primary': color.get('message', 'warning', 'primary'),
  'message/warning/02': color.get('message', 'warning', '02'),
  'message/warning/03': color.get('message', 'warning', '03'),
  'message/warning/04': color.get('message', 'warning', '04'),
  'message/warning/05': color.get('message', 'warning', '05'),
  'message/warning/06': color.get('message', 'warning', '06'),
  'message/error/primary': color.get('message', 'error', 'primary'),
  'message/error/02': color.get('message', 'error', '02'),
  'message/error/03': color.get('message', 'error', '03'),
  'message/error/04': color.get('message', 'error', '04'),
  'message/error/05': color.get('message', 'error', '05'),
  'message/error/06': color.get('message', 'error', '06'),
  'message/info/primary': color.get('message', 'info', 'primary'),
  'message/info/02': color.get('message', 'info', '02'),
  'message/info/03': color.get('message', 'info', '03'),
  'message/info/04': color.get('message', 'info', '04'),
  'message/info/05': color.get('message', 'info', '05'),
  'message/info/06': color.get('message', 'info', '06'),
  'message/neutral/primary': color.get('message', 'neutral', 'primary'),
  'message/neutral/02': color.get('message', 'neutral', '02'),
  'message/neutral/03': color.get('message', 'neutral', '03'),
  'message/neutral/04': color.get('message', 'neutral', '04'),
  'message/neutral/05': color.get('message', 'neutral', '05'),
  'message/neutral/06': color.get('message', 'neutral', '06'),
  'message/info-subtle/primary': color.get('message', 'info-subtle', 'primary'),
  'message/info-subtle/02': color.get('message', 'info-subtle', '02'),
  'message/info-subtle/03': color.get('message', 'info-subtle', '03'),
  'message/info-subtle/04': color.get('message', 'info-subtle', '04'),
  'message/info-subtle/05': color.get('message', 'info-subtle', '05'),
  'message/info-subtle/06': color.get('message', 'info-subtle', '06'),
  'message/caution/primary': color.get('message', 'caution', 'primary'),
  'message/caution/02': color.get('message', 'caution', '02'),
  'message/caution/03': color.get('message', 'caution', '03'),
  'message/caution/04': color.get('message', 'caution', '04'),
  'message/caution/05': color.get('message', 'caution', '05'),
  'message/caution/06': color.get('message', 'caution', '06'),
}
